import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-492a9826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skeleton-container" }

import { withDefaults, computed } from "vue";

type Props = {
  rows?: number;
  cols?: number;
};


export default /*#__PURE__*/_defineComponent({
  props: {
    rows: { default: 4 },
    cols: { default: 5 }
  },
  setup(__props: any) {

const props = __props as { rows: number, cols: number }

_useCssVars(_ctx => ({
  "0c90c868": (_ctx.$props.cols)
}))



const totalDivs = computed(() => Array(props.cols * props.rows).keys());


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(totalDivs), (_item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "item"
      }, "   "))
    }), 128))
  ]))
}
}

})